import axios from 'axios';

export type ErrorName =
    | 'BadRequest'
    | 'UniqueConstraint'
    | 'ResourceNotFound'
    | 'AccessDenied'
    | 'OptimisticLocking'
    | 'ValidationError'
    | 'InvalidParameterForInventoryCategory'
    | 'SystemError';

export type APIError = {
    errorName: ErrorName;
    message: string;
    resource?: string;
    fields?: Record<string, unknown>;
    traceId?: string;
    timestamp?: string;
};

export function parseApiError(error: unknown): APIError | null {
    if (axios.isAxiosError(error) && error.response?.data?.errorName) {
        return error.response.data as APIError;
    }
    return null;
}

export function getUserMessage(error: unknown): string {
    const apiError = parseApiError(error);
    if (apiError?.message) return apiError.message;
    if (axios.isAxiosError(error)) return error.message || 'Request failed.';
    if (error instanceof Error && error.message) return error.message;
    return 'An unexpected error occurred.';
}

export function logApiError(error: unknown): void {
    const apiError = parseApiError(error);
    if (apiError) {
        console.error('[API Error]', {
            errorName: apiError.errorName,
            message: apiError.message,
            resource: apiError.resource,
            fields: apiError.fields,
            traceId: apiError.traceId,
            timestamp: apiError.timestamp,
        });
    } else {
        console.error('[Error]', error);
    }
}